<template>
  <section class="txt-c ds-search-blank">
    <p class="pb16"><img src='../../assets/images/common/blank.png'/></p>
    <p class="f14 c-gray">{{tip}}</p>
  </section>
</template>

<script>
  export default {
    data() {
      return {};
    },
    props: {
      tip: String
    },
    methods: {}
  };
</script>
